export const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="95"
      height="65"
      viewBox="0 0 95 65"
      fill="none"
    >
      <path d="M64.4643 0L0 65H95L64.4643 34.2105V0Z" fill="#004A80" />
      <path
        d="M70.4018 64.9999H19.1785H17.8125L70.4018 11.9736V64.9999Z"
        fill="#00C0F3"
      />
    </svg>
  );
};
